import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BANNER_HEIGHTS } from './constants';

/**
 * Content container that centers content vertically and handles responsive layout
 */
export const BannerContentContainer = styled(Box)(({ theme }) => ({
  // Layout
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  position: 'relative',
  zIndex: 3,

  // Height management
  height: '100%',
  minHeight: BANNER_HEIGHTS.MOBILE,

  // Mobile styles
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left',
    justifyContent: 'flex-start',
  },

  // Desktop styles
  [theme.breakpoints.up('md')]: {
    minHeight: BANNER_HEIGHTS.DESKTOP,
  },
}));

/**
 * Container for banner text content with responsive flex behavior
 */
export const BannerTextContainer = styled(Box)(({ theme }) => ({
  // Layout
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flex: 1,

  // Desktop styles
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
  },

  // Mobile styles - stack content vertically
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(1),
    order: 2,
    alignItems: 'flex-start',
  },
}));
